import { Component } from '@angular/core';
import BaseIndexPageConfig from '../../../../components/pages/base-index-page/base-index-page.config';
import { DataTableColumnActions } from '../../../../components/widgets/data-table/columns/data-table-column-actions/data-table-column-actions.config';
import { DataTableColumnText } from '../../../../components/widgets/data-table/columns/data-table-column-text/data-table-column-text.config';
import ApiOptionsConfig from '../../../../services/api/api-options.config';
import { RouteService } from '../../../../services/route.service';
import { BaseIndexPageComponent } from '../../../../components/pages/base-index-page/base-index-page.component';
import { SpecialisationsService } from 'src/app/services/api/hr/specialisations.service';

@Component({
  selector: 'app-specialisation-index-page',
  imports: [BaseIndexPageComponent],
  templateUrl: './specialisation-index-page.component.html',
  styleUrl: './specialisation-index-page.component.scss'
})
export class SpecialisationIndexPageComponent {
  list: any[] = [];
  baseIndexPageConfig: BaseIndexPageConfig;

  constructor(
    protected specialisationsService: SpecialisationsService,
    private routeService: RouteService
  ) {
    this.baseIndexPageConfig = {
      pageTitle: 'Specialisations',
      cardTitle: 'Manage Specialisations',
      addNewItemButton: {
        type: 'success',
        title: 'Add Specialisation',
        onClick: () => {
          this.routeService.specialisationCreate()
        }
      },
      dataTable: {
        data: [],
        searchModel: {
          code: null,
          name: null,
        },
        pagination: null,
        columns: [          
          new DataTableColumnText({
            attribute: 'employeeSpecialisationId',
            header: 'Id',
            filter: 'text',
            width: '80px',
            value: (item: any) => {
              return item.employeeSpecialisationId;
            }
          }),
          new DataTableColumnText({
            attribute: 'code',
            header: 'Code',
            filter: 'text',
            value: (item: any) => {
              return item.code;
            }
          }),
          new DataTableColumnText({
            attribute: 'name',
            header: 'Name',
            filter: 'text',
            value: (item: any) => {
              return item.name;
            }
          }),
          new DataTableColumnActions({
            header: 'Actions',
            attribute: 'actions',
            style: { width: '50px' },
            buttons: [
              {
                icon: 'fa-eye',
                tooltip: 'View specialisation details',
                onClick: (item: any) => {
                  this.routeService.specialisationDetail(item.employeeSpecialisationId)
                }
              },
              {
                icon: 'fa-edit',
                tooltip: 'Edit specialisation',
                onClick: (item: any) => {
                  this.routeService.specialisationUpdate(item.employeeSpecialisationId)
                }
              },
              {
                icon: 'fa-trash',
                tooltip: 'Delete specialisation',
                onClick: (item: any) => {
                  this.baseIndexPageConfig.dataTable.data = this.baseIndexPageConfig.dataTable.data.filter(
                    (specialisation: any) => specialisation.employeeSpecialisationId !== item.employeeSpecialisationId
                  );
                },
                isDelete: true
              }
            ]
          })
        ]
      },
      apiListService: (options: ApiOptionsConfig) => this.specialisationsService.list(options),
      responseListModelName: 'employeeSpecialisations',
    }
  }
}
